import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcQr(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.969 2.5c-1.582 0-2.865 1.231-2.865 2.75v3c0 .414.35.75.781.75s.782-.336.782-.75v-3c0-.69.583-1.25 1.302-1.25h3.125c.431 0 .781-.336.781-.75s-.35-.75-.781-.75zM19.031 2.5c1.582 0 2.865 1.231 2.865 2.75v3c0 .414-.35.75-.782.75-.43 0-.78-.336-.78-.75v-3c0-.69-.584-1.25-1.303-1.25h-3.125c-.431 0-.781-.336-.781-.75s.35-.75.781-.75zM2.104 18.75c0 1.519 1.283 2.75 2.865 2.75h3.125c.431 0 .781-.336.781-.75s-.35-.75-.781-.75H4.969c-.72 0-1.302-.56-1.302-1.25v-3c0-.414-.35-.75-.782-.75-.431 0-.78.336-.78.75zM19.031 21.5c1.582 0 2.865-1.231 2.865-2.75v-3c0-.414-.35-.75-.782-.75-.43 0-.78.336-.78.75v3c0 .69-.584 1.25-1.303 1.25h-3.125c-.431 0-.781.336-.781.75s.35.75.781.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.792 12.75c-.72 0-1.302.56-1.302 1.25v3c0 .69.582 1.25 1.302 1.25h3.125c.719 0 1.302-.56 1.302-1.25v-3c0-.69-.583-1.25-1.302-1.25zm.26 4v-2.5h2.604v2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.302 12.75a.51.51 0 0 0-.52.5v1c0 .276.232.5.52.5h1.042a.51.51 0 0 0 .52-.5v-1a.51.51 0 0 0-.52-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.604 15c0-.276.233-.5.521-.5h1.042a.51.51 0 0 1 .52.5v1a.51.51 0 0 1-.52.5h-1.042a.51.51 0 0 1-.52-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.948 12.75a.51.51 0 0 0-.521.5v1c0 .276.233.5.52.5h1.043a.51.51 0 0 0 .52-.5v-1a.51.51 0 0 0-.52-.5zM12.781 16.75c0-.276.233-.5.521-.5h1.042a.51.51 0 0 1 .52.5v1a.51.51 0 0 1-.52.5h-1.042a.51.51 0 0 1-.52-.5zM16.948 16.25a.51.51 0 0 0-.521.5v1c0 .276.233.5.52.5h1.043a.51.51 0 0 0 .52-.5v-1a.51.51 0 0 0-.52-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.792 6c-.72 0-1.302.56-1.302 1.25v3c0 .69.582 1.25 1.302 1.25h3.125c.719 0 1.302-.56 1.302-1.25v-3c0-.69-.583-1.25-1.302-1.25zm.26 4V7.5h2.604V10zM14.088 6c-.72 0-1.302.56-1.302 1.25v3c0 .69.583 1.25 1.302 1.25h3.125c.719 0 1.302-.56 1.302-1.25v-3c0-.69-.583-1.25-1.302-1.25zm.26 4V7.5h2.604V10z",
    clipRule: "evenodd"
  })));
}
var IcQr = createNolIcon(/*#__PURE__*/forwardRef(SvgIcQr));

export { IcQr as I };
